import { useGraphQLQuery } from '@betterment/graphql';
import { Box, Card, H3, Separator, Text } from '@betterment/samba-react';
import { CardLoader, ErrorBoundary, SambaAutoLink } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { FiveTwoNineEligibilityDocument } from './graphql/query.fiveTwoNineEligibility.generated';

import { urlBuilder } from '../../../Shared/urlBuilder';

export const FiveTwoNineLearnMore: React.FC = () => {
  const purposeId = useRequiredParam('purposeId');
  const { data } = useGraphQLQuery(FiveTwoNineEligibilityDocument, {
    variables: { id: purposeId },
    throwOnError: true,
  });

  if (!data) return <CardLoader />;
  if (
    !data.fiveTwoNineOnboardingOption?.isEligible ||
    !['PurposeRetirementGrowth', 'PurposeRetirementIncome'].includes(data.purpose.__typename)
  ) {
    return null;
  }

  const five29Account = data.legalSubAccounts.find(subAccount => subAccount?.__typename === 'Five29Account');
  const five29SignupUrl = five29Account?.legacyGoalId
    ? urlBuilder.appFiveTwoNineSignup.absolute({ goal_id: five29Account.legacyGoalId })
    : urlBuilder.appFiveTwoNineSignup.absolute();

  return (
    <Card css={{ padding: 'space.300', display: 'grid', gap: 'space.300' }}>
      <Card.Header>
        <H3 variant="title200">Save for education with a 529 account</H3>
      </Card.Header>
      <Separator />
      <Card.Content css={{ display: 'grid', gap: 'space.200' }}>
        <Text css={{ mb: 'space.100' }}>
          Invest towards educational expenses with this flexible, tax-advantaged account. Set up a new account or
          connect an existing 529 with Betterment.
        </Text>
        <Box css={{ display: 'flex' }}>
          <SambaAutoLink to={five29SignupUrl} variant="solidPrimary">
            Learn more
          </SambaAutoLink>
        </Box>
      </Card.Content>
    </Card>
  );
};

export const FiveTwoNineCard: React.FC = () => {
  return (
    <ErrorBoundary feature="FiveTwoNine" fallbackType="none">
      <FiveTwoNineLearnMore />
    </ErrorBoundary>
  );
};
